"use client";
import { cn } from "@/util/cn";
import { motion } from "motion/react";

export default function Col({
  children,
  className,
  animate,
}: {
  children: React.ReactNode;
  className?: string;
  animate?: boolean;
}) {
  if (!animate) {
    return <div className={cn("flex flex-col", className)}>{children}</div>;
  }
  return (
    <motion.div
      className={cn("flex flex-col", className)}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
    >
      {children}
    </motion.div>
  );
}
